/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayWithAutopay/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function PayWithAutopay({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/PayWithAutopay"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let paymentsEditAutopayMethodValueData = fromData.useDataValue({ viewPath,
context: 'payments_edit_autopay',
path: 'method',
})
let constantData = 'autopay'
let aggregateData = fromAggregate.equals(paymentsEditAutopayMethodValueData, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<button
  data-testid="PayWithAutopay.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mr-1-3z27c': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PayWithAutopay.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mr-1-3z27c': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="payments_edit_autopay.method"
 data="'autopay'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 paddingRight={0}
/>
<div
  data-testid="PayWithAutopay.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Autopay"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Autocharged on credit card/bank"
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}